export const environment = {
  production: true,
  buildId: '3337077981821601',
  configFile: 'config.json',
};
